import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getCurrentPageByIndex, buildPagingArray } from './pagination-helper';
import { toAbsoluteUrlFromObject, toSearchString } from 'utils/url';
import PrevIcon from '@tradera/tradera-ui/icons/arrow-left.svg?jsx';
import NextIcon from '@tradera/tradera-ui/icons/arrow-right.svg?jsx';
import * as gtm from '../search-gtm';

class DiscoverPagination extends Component {
    static propTypes = {
        pagination: PropTypes.object,
        location: PropTypes.object,
        queryParams: PropTypes.object
    };

    getLinkValue = page => {
        const { location, queryParams } = this.props;
        if (page && location && queryParams) {
            const query = {
                ...queryParams,
                paging: page.paging,
                spage: page.pageIndex == 1 ? undefined : page.pageIndex
            };
            const url = {
                ...location,
                search: toSearchString(query)
            };
            return url;
        }
    };

    onLinkClicked(trackingLabel) {
        gtm.trackNavigation(trackingLabel);
    }

    getNavLink = (direction = 'next') => {
        const {
            pagination: { pageLinks, pageIndex }
        } = this.props;

        let url = {};
        const currentIndex = getCurrentPageByIndex(pageLinks, pageIndex);

        //if more links exist before the current page
        if (direction === 'previous') {
            let hasPreviousLink = pageLinks[currentIndex - 1];
            if (hasPreviousLink) {
                const previousLink = pageLinks[currentIndex - 1];
                url = this.getLinkValue(previousLink);
            }
        }
        //if more links exist after the current page
        if (direction === 'next') {
            let hasNextLink = pageLinks.length > currentIndex + 1;
            if (hasNextLink) {
                const nextLink = pageLinks[currentIndex + 1];
                url = this.getLinkValue(nextLink);
            }
        }

        return url;
    };

    renderPageLinks = (pageLinks, viewClass) => {
        return pageLinks.map((link, index) => {
            return (
                <li
                    className={`page-item ${viewClass} ${
                        link.active ? 'active' : ''
                    }${link.dotted ? 'disabled' : ''}`}
                    key={index}>
                    <Link
                        to={this.getLinkValue(link.pagination) || {}}
                        className="page-link"
                        onClick={() =>
                            this.onLinkClicked(`Page ${link.pageIndex}`)
                        }>
                        {link.pagination ? link.pageIndex : '...'}
                    </Link>
                </li>
            );
        });
    };

    render() {
        const { pagination } = this.props;
        if (!pagination || (pagination && pagination.pageCount < 2)) {
            return null;
        }

        const { pageIndex, pageCount } = pagination;

        const desktopPagination = buildPagingArray(pagination);
        const mobilePagination = buildPagingArray(pagination, 1, 2);
        const prevLink = this.getNavLink('previous');
        const nextLink = this.getNavLink('next');

        return (
            <div className="pb-3" data-search-results-pagination>
                <Helmet>
                    {prevLink.pathname && (
                        <link
                            rel="prev"
                            href={toAbsoluteUrlFromObject(prevLink)}
                        />
                    )}
                    {nextLink.pathname && (
                        <link
                            rel="next"
                            href={toAbsoluteUrlFromObject(nextLink)}
                        />
                    )}
                </Helmet>
                <nav aria-label="Search results pages">
                    <ul className="pagination d-flex justify-content-center">
                        {pageIndex !== 1 ? (
                            <li className="page-item">
                                <Link
                                    to={prevLink}
                                    className="page-link h-100"
                                    onClick={() =>
                                        this.onLinkClicked('Previous page')
                                    }
                                    rel="prev">
                                    <span className="d-sm-block d-none">
                                        Föregående
                                    </span>
                                    <PrevIcon className="icon icon-sm icon-dark d-sm-none d-block h-100" />
                                </Link>
                            </li>
                        ) : null}
                        {this.renderPageLinks(
                            desktopPagination,
                            'd-none d-md-block'
                        )}
                        {this.renderPageLinks(mobilePagination, 'd-md-none')}
                        {pageIndex !== pageCount ? (
                            <li className="page-item">
                                <Link
                                    to={nextLink}
                                    className="page-link h-100"
                                    onClick={() =>
                                        this.onLinkClicked('Next page')
                                    }
                                    rel="next">
                                    <span className="d-sm-block d-none">
                                        Nästa
                                    </span>
                                    <NextIcon className="icon icon-sm icon-dark d-sm-none d-block h-100" />
                                </Link>
                            </li>
                        ) : null}
                    </ul>
                </nav>
            </div>
        );
    }
}

export default withRouter(DiscoverPagination);



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/pagination/discover-pagination.jsx